{
  "name": "jspsych",
  "version": "8.3.0",
  "description": "Behavioral experiments in a browser",
  "type": "module",
  "main": "dist/index.cjs",
  "exports": {
    ".": {
      "import": "./dist/index.js",
      "require": "./dist/index.cjs"
    },
    "./css/*": "./css/*"
  },
  "typings": "dist/index.d.ts",
  "unpkg": "dist/index.browser.min.js",
  "files": [
    "src",
    "dist",
    "css"
  ],
  "source": "src/index.ts",
  "scripts": {
    "test": "jest",
    "test:watch": "npm test -- --watch",
    "tsc": "tsc",
    "build:js": "rollup --config",
    "build:styles": "webpack-cli",
    "build": "run-p build:js build:styles",
    "build:watch": "run-p \"build:js -- --watch\" \"build:styles watch\"",
    "prepack": "cp ../../README.md ."
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/jspsych/jsPsych.git",
    "directory": "packages/jspsych"
  },
  "author": "Josh de Leeuw",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/jspsych/jsPsych/issues"
  },
  "homepage": "https://www.jspsych.org",
  "dependencies": {
    "auto-bind": "^4.0.0",
    "random-words": "^1.1.1",
    "seedrandom": "^3.0.5",
    "type-fest": "^2.9.0"
  },
  "devDependencies": {
    "@fontsource/open-sans": "4.5.3",
    "@jspsych/config": "^3.3.4",
    "@types/dom-mediacapture-record": "^1.0.11",
    "base64-inline-loader": "^2.0.1",
    "css-loader": "^6.6.0",
    "mini-css-extract-plugin": "^2.5.3",
    "npm-run-all": "^4.1.5",
    "replace-in-file-webpack-plugin": "^1.0.6",
    "sass": "^1.43.5",
    "sass-loader": "^12.4.0",
    "webpack": "^5.76.0",
    "webpack-cli": "^4.9.2",
    "webpack-remove-empty-scripts": "^0.7.2"
  }
}
